module.exports = __webpack_public_path__ + "fonts/Barlow-SemiBold.f2c7a18.woff2";